
export function camelize(str){
        
    return str.replace('_',' ').replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (word, index) {
        return word.toUpperCase();
    }).replace(/\s+/g, '')
}